import React, { useState, useEffect  } from 'react'

import BannerColor from './Steps/BannerColor'
import BannerPlace from './Steps/BannerPlace'
import ButtonColor from './Steps/ButtonColor'
import FontSize from './Steps/FontSize'
import FrameComponent from './FrameComponent'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import StepConnector from '@material-ui/core/StepConnector'
import Button from '@material-ui/core/Button'




import { GetText as $ } from 'stores/UITexts'


export const BannerToolContext = React.createContext()

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#394074',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#394074',
    },
  },
  line: {
    borderColor: '#EBEBEB',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector)

function getSteps() {
  return ['Banner Yeri', 'Banner Rengi', 'Button Rengi', 'Font Büyüklüğü']
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return <BannerPlace />
    case 1:
      return <BannerColor />
    case 2:
      return <ButtonColor />
    case 3:
      return <FontSize />
    default:
      return <BannerPlace />
  }
}

const BannerCustomization = props => {
  const [formdata, SetFormData] = useState({
    form1: {
      value: 1,
    },
    form2: {
      value: '#414042',
    },
    form3: {
      value: '#ff8724',
    },
    form4: {
      value: 14,
    },
  })

  const classes = useStyles()
  const [activeStep, setActiveStep] = React.useState(0)

  const steps = getSteps()

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleReset = () => {
    setActiveStep(0)
    SetFormData({
      form1: {
        value: 1,
      },
      form2: {
        value: '#414042',
      },
      form3: {
        value: '#ff8724',
      },
      form4: {
        value: 14,
      },
    })
  }

  const ActiveButtonStyles = {
    textTransform: 'capitalize',
    fontFamily: 'Quicksand',
    fontSize: '14px !important',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: '#383F73',
    boxShadow: '0px 0px 20px 1px #0000000D',
    width: '160px',
    height: '40px',
    borderRadius: '5px',
  }
  const PassiveButtonStyles = {
    textTransform: 'capitalize',
    fontFamily: 'Quicksand',
    fontSize: '14px !important',
    fontWeight: '700',
    color: '#383F73',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 20px 1px #0000000D',
    width: '160px',
    height: '40px',
    border: '1px solid #394074',
    borderRadius: '5px',
  }

  function updateSiteUiTheme( ) {
    props.siteInfo.site.uiTheme = { 
      "bannerBackgroundColor": formdata.form2.value,
      "bannerButtonColor": formdata.form3.value,
      "bannerTextSize": `${formdata.form4.value}`,
      "bannerPlace": `${formdata.form1.value}`,
    } 
  }
  
  return (
    /* <>
       <CssBaseline />
       <Container component={Box} p={4}>
         <Paper component={Box} p={3}>
           <LinaerStepper />
         </Paper>
       </Container>
     </>
     <User />
    <span style={{fontSize:20,textAlign:'center', fontWeight:500}}>Yakında banner için customization işlemleri sizlerle !</span>
    */

    // circle color değişecek
    <BannerToolContext.Provider value={formdata}>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
          {steps.map((label, index) => {
            const stepProps = {}
            const labelProps = {}
            return (
              <Step key={label} {...stepProps}>
                <StepLabel
                  {...labelProps}
                  style={{
                    fontFamily: 'Quicksand',
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#FFFFFF',
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            )
          })}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '25%' }}>
               
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: '5px' }}>
                  <Button onClick={handleReset} style={PassiveButtonStyles}>
                    Yeniden Tasarla
                  </Button>
                 {updateSiteUiTheme()}
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', width: '75%', boxShadow: '0px 0px 20px 1px #0000000D' }}>
                <FrameComponent />
              </div>
            </div>
          ) : (
            <div>
              <span className={classes.instructions}>{getStepContent(activeStep)}</span>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '25%' }}>
                <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                  {activeStep === 0 ? (
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.0895 16.4646C11.9568 16.6033 11.8527 16.7668 11.7833 16.9459C11.6374 17.3009 11.6374 17.6991 11.7833 18.0542C11.8527 18.2332 11.9568 18.3967 12.0895 18.5354L16.4645 22.9104C16.7392 23.185 17.1116 23.3393 17.5 23.3393C17.8883 23.3393 18.2608 23.185 18.5354 22.9104C18.81 22.6358 18.9643 22.2634 18.9643 21.875C18.9643 21.4867 18.81 21.1142 18.5354 20.8396L16.6395 18.9584H21.875C22.2617 18.9584 22.6327 18.8047 22.9062 18.5312C23.1796 18.2577 23.3333 17.8868 23.3333 17.5C23.3333 17.1132 23.1796 16.7423 22.9062 16.4688C22.6327 16.1953 22.2617 16.0417 21.875 16.0417H16.6395L18.5354 14.1604C18.6721 14.0249 18.7806 13.8636 18.8546 13.6859C18.9286 13.5082 18.9668 13.3175 18.9668 13.125C18.9668 12.9325 18.9286 12.7419 18.8546 12.5642C18.7806 12.3865 18.6721 12.2252 18.5354 12.0896C18.3998 11.9529 18.2385 11.8444 18.0608 11.7704C17.8831 11.6964 17.6925 11.6582 17.5 11.6582C17.3074 11.6582 17.1168 11.6964 16.9391 11.7704C16.7614 11.8444 16.6001 11.9529 16.4645 12.0896L12.0895 16.4646ZM2.91663 17.5C2.91663 20.3843 3.77192 23.2039 5.37436 25.6021C6.9768 28.0003 9.2544 29.8695 11.9192 30.9733C14.5839 32.077 17.5161 32.3658 20.345 31.8031C23.1739 31.2404 25.7724 29.8515 27.8119 27.812C29.8515 25.7725 31.2404 23.174 31.8031 20.3451C32.3658 17.5162 32.077 14.584 30.9732 11.9192C29.8694 9.25446 28.0002 6.97686 25.602 5.37442C23.2038 3.77198 20.3843 2.91669 17.5 2.91669C15.5849 2.91669 13.6885 3.2939 11.9192 4.02678C10.1498 4.75966 8.54217 5.83386 7.18799 7.18805C4.45308 9.92295 2.91663 13.6323 2.91663 17.5ZM29.1666 17.5C29.1666 19.8075 28.4824 22.0631 27.2004 23.9817C25.9185 25.9002 24.0964 27.3956 21.9646 28.2786C19.8328 29.1616 17.487 29.3927 15.2239 28.9425C12.9608 28.4924 10.882 27.3812 9.25038 25.7496C7.61877 24.118 6.50763 22.0392 6.05747 19.7761C5.6073 17.513 5.83834 15.1672 6.72137 13.0354C7.60439 10.9036 9.09973 9.08149 11.0183 7.79954C12.9369 6.51759 15.1925 5.83335 17.5 5.83335C20.5942 5.83335 23.5616 7.06252 25.7495 9.25044C27.9375 11.4384 29.1666 14.4058 29.1666 17.5Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  ) : (
                    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.0896 16.4646C11.9568 16.6033 11.8527 16.7668 11.7833 16.9459C11.6375 17.3009 11.6375 17.6991 11.7833 18.0542C11.8527 18.2332 11.9568 18.3967 12.0896 18.5354L16.4646 22.9104C16.7392 23.185 17.1116 23.3393 17.5 23.3393C17.8883 23.3393 18.2608 23.185 18.5354 22.9104C18.81 22.6358 18.9643 22.2634 18.9643 21.875C18.9643 21.4867 18.81 21.1142 18.5354 20.8396L16.6396 18.9584H21.875C22.2618 18.9584 22.6327 18.8047 22.9062 18.5312C23.1797 18.2577 23.3333 17.8868 23.3333 17.5C23.3333 17.1132 23.1797 16.7423 22.9062 16.4688C22.6327 16.1953 22.2618 16.0417 21.875 16.0417H16.6396L18.5354 14.1604C18.6721 14.0249 18.7806 13.8636 18.8546 13.6859C18.9287 13.5082 18.9668 13.3175 18.9668 13.125C18.9668 12.9325 18.9287 12.7419 18.8546 12.5642C18.7806 12.3865 18.6721 12.2252 18.5354 12.0896C18.3998 11.9529 18.2385 11.8444 18.0608 11.7704C17.8831 11.6964 17.6925 11.6582 17.5 11.6582C17.3075 11.6582 17.1169 11.6964 16.9391 11.7704C16.7614 11.8444 16.6001 11.9529 16.4646 12.0896L12.0896 16.4646ZM2.91666 17.5C2.91666 20.3843 3.77195 23.2039 5.37439 25.6021C6.97683 28.0003 9.25443 29.8695 11.9192 30.9733C14.5839 32.077 17.5162 32.3658 20.3451 31.8031C23.1739 31.2404 25.7724 29.8515 27.812 27.812C29.8515 25.7725 31.2404 23.174 31.8031 20.3451C32.3658 17.5162 32.077 14.584 30.9732 11.9192C29.8695 9.25446 28.0003 6.97686 25.6021 5.37442C23.2038 3.77198 20.3843 2.91669 17.5 2.91669C15.5849 2.91669 13.6885 3.2939 11.9192 4.02678C10.1499 4.75966 8.5422 5.83386 7.18802 7.18805C4.45311 9.92295 2.91666 13.6323 2.91666 17.5ZM29.1667 17.5C29.1667 19.8075 28.4824 22.0631 27.2005 23.9817C25.9185 25.9002 24.0964 27.3956 21.9646 28.2786C19.8328 29.1616 17.4871 29.3927 15.2239 28.9425C12.9608 28.4924 10.882 27.3812 9.25041 25.7496C7.6188 24.118 6.50766 22.0392 6.0575 19.7761C5.60733 17.513 5.83837 15.1672 6.7214 13.0354C7.60442 10.9036 9.09976 9.08149 11.0183 7.79954C12.9369 6.51759 15.1925 5.83335 17.5 5.83335C20.5942 5.83335 23.5616 7.06252 25.7496 9.25044C27.9375 11.4384 29.1667 14.4058 29.1667 17.5Z"
                        fill="#383F73"
                      />
                    </svg>
                  )}
                </Button>
                <Button onClick={handleNext}>
                  <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M22.9105 18.5354C23.0433 18.3968 23.1473 18.2332 23.2168 18.0542C23.3626 17.6991 23.3626 17.3009 23.2168 16.9459C23.1473 16.7668 23.0433 16.6033 22.9105 16.4646L18.5355 12.0896C18.2609 11.815 17.8884 11.6607 17.5001 11.6607C17.1117 11.6607 16.7393 11.815 16.4647 12.0896C16.1901 12.3642 16.0358 12.7367 16.0358 13.125C16.0358 13.5134 16.1901 13.8858 16.4647 14.1604L18.3605 16.0417H13.1251C12.7383 16.0417 12.3674 16.1953 12.0939 16.4688C11.8204 16.7423 11.6668 17.1133 11.6668 17.5C11.6668 17.8868 11.8204 18.2577 12.0939 18.5312C12.3674 18.8047 12.7383 18.9584 13.1251 18.9584H18.3605L16.4647 20.8396C16.328 20.9752 16.2195 21.1365 16.1455 21.3142C16.0714 21.4919 16.0333 21.6825 16.0333 21.875C16.0333 22.0675 16.0714 22.2582 16.1455 22.4359C16.2195 22.6136 16.328 22.7749 16.4647 22.9104C16.6002 23.0471 16.7615 23.1556 16.9392 23.2297C17.117 23.3037 17.3076 23.3418 17.5001 23.3418C17.6926 23.3418 17.8832 23.3037 18.0609 23.2297C18.2386 23.1556 18.3999 23.0471 18.5355 22.9104L22.9105 18.5354ZM32.0834 17.5C32.0834 14.6157 31.2281 11.7962 29.6257 9.39796C28.0232 6.99974 25.7456 5.13056 23.0809 4.02678C20.4161 2.92301 17.4839 2.63421 14.655 3.19691C11.8261 3.75961 9.22763 5.14854 7.18811 7.18805C5.1486 9.22757 3.75967 11.8261 3.19697 14.655C2.63427 17.4838 2.92307 20.4161 4.02684 23.0808C5.13062 25.7456 6.9998 28.0232 9.39802 29.6256C11.7962 31.2281 14.6158 32.0834 17.5001 32.0834C21.3678 32.0834 25.0772 30.5469 27.8121 27.812C30.547 25.0771 32.0834 21.3678 32.0834 17.5ZM5.83342 17.5C5.83342 15.1926 6.51766 12.9369 7.79961 11.0184C9.08156 9.0998 10.9036 7.60445 13.0354 6.72143C15.1673 5.83841 17.513 5.60737 19.7761 6.05753C22.0393 6.50769 24.1181 7.61883 25.7497 9.25045C27.3813 10.8821 28.4924 12.9609 28.9426 15.224C29.3927 17.4871 29.1617 19.8329 28.2787 21.9647C27.3957 24.0965 25.9003 25.9186 23.9817 27.2005C22.0632 28.4825 19.8075 29.1667 17.5001 29.1667C14.4059 29.1667 11.4384 27.9375 9.25051 25.7496C7.06258 23.5617 5.83342 20.5942 5.83342 17.5Z"
                      fill="#394074"
                    />
                  </svg>
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </BannerToolContext.Provider>
  )
}
export default BannerCustomization